import mapKnownValues from "@/utils/mapKnownValues";

export class AuditLogItem {
  id = "";
  action = "";
  entityType = "";
  entityId = "";
  createdBy = "";
  description = "";
  entityProperty = "";
  entityOrg = "";
  createdAt = new Date();

  constructor(params: Partial<AuditLogItem>) {
    mapKnownValues(this, params);
  }
}
